/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_YesInputs */

const en_mk_cmp_yes = /** @type {(inputs: Mk_Cmp_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const id_mk_cmp_yes = /** @type {(inputs: Mk_Cmp_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Mk_Cmp_YesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_yes = /** @type {((inputs?: Mk_Cmp_YesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_YesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_yes(inputs)
	return en_mk_cmp_yes(inputs)
});